import { IS_WEB } from 'constants/platform'
import React, { useMemo } from 'react'

import { Box } from 'widgets/Box'
import { CoachItem } from 'widgets/CoachItem'
import { FlatList } from 'widgets/FlatList'
import { Text } from 'widgets/Text'

import { useClientSubscriptions } from 'hooks/useClientSubscriptions'
import { useMultipleUsers } from 'hooks/useMultipleUsers'
import { useUser } from 'hooks/useUser'

import { UserType } from 'types/user'

type UserCoachesProps = {
  userId: string | undefined
}

export const UserCoaches = ({ userId }: UserCoachesProps) => {
  const { data: user, isLoading: isLoadingUser } = useUser({ userId })
  const { data: subscriptions, isLoading: isLoadingClientSubscriptions } = useClientSubscriptions({
    userId,
  })

  const { data: subscribedTrainers } = useMultipleUsers({
    userIds: subscriptions?.map((sub) => sub.program.trainer.id ?? '') ?? [],
  })

  const isLoading = isLoadingUser || isLoadingClientSubscriptions

  const trainers = useMemo(() => {
    const returnTrainers = subscribedTrainers ? [...subscribedTrainers] : []

    if (user?.type === 'trainer') {
      returnTrainers.unshift(user)
    }

    return returnTrainers
  }, [subscribedTrainers, user])

  return (
    <Box align='center' justifyContent='center'>
      {isLoading && (
        <Text align='center' fontSize='sm' color='greyDark'>
          Loading...
        </Text>
      )}
      {subscriptions && !isLoading && (
        <Box flexDirection='column' width='100%'>
          {trainers.length > 0 && (
            <Box flexDirection={IS_WEB ? 'column' : 'row'} width='100%'>
              <FlatList<UserType>
                horizontal
                data={trainers}
                loading={isLoadingClientSubscriptions}
                renderItem={({ item }) => (
                  <CoachItem
                    displayedForUser={user as UserType}
                    user={item}
                    isSquare
                    withLeaderboardPosition
                  />
                )}
                keyExtractor={(item) => `${item?.id}`}
              />
            </Box>
          )}
        </Box>
      )}
    </Box>
  )
}
